import React from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Home from './components/pages/Home';
import Navigation from './components/pages/Navigation';
import About from './components/pages/About';
import Service from './components/pages/Service';
import Blog from './components/pages/Blog';
import BlogDetails from './components/pages/BlogDetails';
import Project from './components/pages/Project';
import Apartments from './components/pages/Apartments';
import Contact from './components/pages/Contact';


function App() {
  return (
    <div>
      <Router>
        <Navigation />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/service" component={Service} />
          <Route path="/blog" component={Blog} />
          <Route path="/blogdetails" component={BlogDetails} />
          <Route path="/project" component={Project} />
          <Route path="/apartments" component={Apartments} />
          <Route path="/contact" component={Contact} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
